'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    OverlayCalendar: ()=>OverlayCalendar
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../Drawer/index.cjs");
const external_OverlaySearchHeader_index_cjs_namespaceObject = require("../../OverlaySearchHeader/index.cjs");
const Calendar_cjs_namespaceObject = require("../Calendar/Calendar.cjs");
function OverlayCalendar({ mode = 'single', handleCalendarChange, components, open = false, handleDrawerState, heading = 'Choose Dates', popOverText, selected, footer, subHeading, ...restProps }) {
    const handleClose = ()=>{
        handleDrawerState(false);
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: "flex flex-row",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Drawer, {
            title: "Calendar",
            description: "Overlay Calendar",
            direction: "bottom",
            showCloseButton: false,
            showDragHandle: false,
            open: open,
            scroll: "body",
            footer: footer,
            stickyFooter: !!footer,
            headingCustomNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_OverlaySearchHeader_index_cjs_namespaceObject.OverlayTitle, {
                heading: heading,
                subHeading: subHeading,
                handleClose: handleClose,
                popOverText: popOverText
            }),
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: "relative flex w-full p-4",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Calendar_cjs_namespaceObject.Calendar, {
                    isMobile: true,
                    mode: mode,
                    handleCalendarChange: handleCalendarChange,
                    components: components,
                    selected: selected,
                    ...restProps
                })
            })
        })
    });
}
exports.OverlayCalendar = __webpack_exports__.OverlayCalendar;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "OverlayCalendar"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
